module.exports = "../dist/img/img_3-26.469c.jpg";